import { render } from "./Sticker.vue?vue&type=template&id=2903724f"
import script from "./Sticker.vue?vue&type=script&lang=js"
export * from "./Sticker.vue?vue&type=script&lang=js"

import "./Sticker.vue?vue&type=style&index=0&id=2903724f&lang=scss"
script.render = render

export default script